module.exports = __webpack_public_path__ + "static/media/clock-calendar.12488506.svg";